import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add_white",
  "use": "icon-add_white-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol viewBox=\"0 0 8 8\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add_white\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.66667 0H3.33334V3.33341H5.82822e-08L0 4.66674H3.33334V8H4.66667V4.66674H8V3.33341H4.66667V0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol